import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

export const LEVELS = ["Estreante", "Iniciante B", "Iniciante A", "Intermediário", "Avançado"];
export const SIDES = ["Esquerda", "Direita", "Ambos"];
export const POINT_CATS = {
  campeao: "Campeão", vice: "Vice-campeão", terceiro: "3º lugar", quarto: "4º lugar",
  destaque: "Atleta destaque", participacao: "Participação",
};
export const STAGE_STATUS = {
  inscricoes_abertas: "Inscrições abertas", em_andamento: "Em andamento", finalizada: "Finalizada",
};
export const CHARGE_STATUS = {
  pago: "Pago", pendente: "Pendente", atrasado: "Em atraso", aguardando: "Aguardando confirmação",
};
export const EMOJIS = ["🔥", "⚡", "🦈", "🦅", "🐺", "🚀", "👑", "🎯", "💪", "🌊", "🐯", "⭐", "🏝️", "🦁", "🌟", "🍀", "🏆", "😎", "🥇", "🐐", "🦍", "🐉", "☀️", "💎"];

export const fileUrl = (p) => (!p ? null : p.startsWith("http") ? p : `${API}/files/${p}`);
export const avatarOf = (u) => fileUrl(u?.photo) || u?.google_picture || null;
export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  return typeof d === "string" ? d : "Algo deu errado. Tente novamente.";
};
export const brl = (v) => Number(v || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
export const fmtDate = (d) => {
  if (!d) return "—";
  const [y, m, day] = d.slice(0, 10).split("-");
  return `${day}/${m}/${y}`;
};
export const waLink = (phone, text = "") => {
  let n = (phone || "").replace(/\D/g, "");
  if (!n) return null;
  if (n.length <= 11) n = `55${n}`;
  return `https://wa.me/${n}${text ? `?text=${encodeURIComponent(text)}` : ""}`;
};
export const igLink = (ig) => (ig ? `https://instagram.com/${ig.replace(/^@/, "")}` : null);
export const firstName = (n) => (n || "").split(" ")[0];
export const approvalMsg = (name) =>
  `Olá ${firstName(name)}! O seu cadastro foi aprovado, faça o login no Circuito Altax: ${window.location.origin}`;
export const overdueMsg = (c, pix) =>
  `Olá ${firstName(c.user?.name)}! Sua cobrança "${c.description}" no valor de ${brl(c.amount)} venceu em ${fmtDate(c.due_date)}. Pague via PIX (copia e cola): ${pix}. Obrigado! Circuito Altax`;
export const shareLink = async (url, title) => {
  if (navigator.share) {
    try { await navigator.share({ title, url }); return "shared"; } catch { return "cancel"; }
  }
  try { await navigator.clipboard.writeText(url); return "copied"; } catch { return "fail"; }
};
